import LocationsPage from './LocationsPage';

export default LocationsPage;
